<template>
	<div class="events-pagination">
		<a
			class="prev"
			v-show="data.timeSpan !== 'range'"
			@click.prevent="prev"
			href="#"
			:title="prevPeriod"
		>
			<span class="far fa-long-arrow-left"></span>
			<span class="prev-label">Prev</span>
		</a>

		<h2 class="events-span-title">
			<span class="events-date-range">
				<span class="month-label">Month of</span>
				{{displayDate}}
			</span>
		</h2>

		<a
			class="next"
			v-show="data.timeSpan !== 'range'"
			@click.prevent="next"
			href="#"
			:title="nextPeriod"
		>
			<span class="next-label">Next</span>
			<span class="far fa-long-arrow-right"></span>
		</a>
	</div>
</template>

<script>
// import { store } from "./_juicebox-store.js";
import moment from "moment";
import { mapActions } from "vuex";

export default {
	name: "events-pagination",
	data() {
		return {
			data: this.$store.state
		};
	},
	computed: {
		displayDate: function() {
			// Here you can change the formatting of the display date.
			let dateRange = this.data.currentDate;
			return moment.unix(dateRange[0]).format("MMMM YYYY");
		},
		timespan: function() {
			return this.data.timeSpan;
		},
		currentDate: function() {
			return this.data.currentDate;
		},
		prevPeriod: function() {
			var current = this.data.currentDate;
			switch (this.data.timeSpan) {
				case "month":
					return moment
						.unix(current[0])
						.subtract(1, "M")
						.format("MMMM YYYY");

				case "day":
					return moment
						.unix(current[0])
						.subtract(1, "days")
						.format("MMMM D, YYYY");

				default:
					return;
			}
		},
		nextPeriod: function() {
			var current = this.data.currentDate;
			switch (this.data.timeSpan) {
				case "month":
					return moment
						.unix(current[0])
						.add(1, "M")
						.format("MMMM YYYY");

				case "day":
					return moment
						.unix(current[0])
						.add(1, "days")
						.format("MMMM D, YYYY");

				default:
					return;
			}
		}
	},
	methods: {
		...mapActions(["setCurrentDate", "loadEvents", "setFilteredEvents"]),
		prev() {
			var dates = {};
			dates.start = moment
				.unix(this.data.currentDate[0])
				.subtract(1, this.data.timeSpan)
				.startOf("month")
				.unix();
			// .format("YYYYMMDD");
			dates.end = moment
				.unix(this.data.currentDate[0])
				.subtract(1, this.data.timeSpan)
				.endOf("month")
				.unix();

			this.setFilteredEvents([]);
			this.loadEvents(dates);
			// Subtract one day, week or month to both dates if it's a range or not.
			this.setCurrentDate({
				date: [dates.start, dates.end],
				span: this.data.timeSpan
			});
		},
		next() {
			var dates = {};
			dates.start = moment
				.unix(this.data.currentDate[0])
				.add(1, this.data.timeSpan)
				.startOf("month")
				.unix();

			dates.end = moment
				.unix(this.data.currentDate[0])
				.add(1, this.data.timeSpan)
				.endOf("month")
				.unix();

			this.setFilteredEvents([]);
			this.loadEvents(dates);

			// Add one day, week or month to both dates if it's a range or not.
			this.setCurrentDate({
				date: [dates.start, dates.end],
				span: this.data.timeSpan
			});
		}
	}
};
</script>

<style lang="scss" scoped>
</style>